import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";
import "./index.scss";
import HeaderAction from "../components/HeaderAction";
import TitleLogo from "../components/TitleLogo";
import Reel from "../components/Reel";
import logoShwePuzzle from "../../../../assets/images/Event-2026/logo.png";
import logoShwePuzzleThadingyutTheme from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/logoShwePuzzle-thadingyut-2025-theme.png";
import logoShwePuzzleNewYear from "../../../../assets/images/Mini-Game/new-year-2025/new-year-title.png";
import { Link, useHistory, useParams } from "react-router-dom";
import PATH from "../../../../config/PATH";
import {
  useDispatch,
  useSelector,
  curStateMiniGame,
  MiniGameProvider,
  useMiniGameAuth,
  setDataSpinLeft,
  getDataSpinUserMiniGame,
} from "../store";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import ActionComponent from "../components/Action";
import MissionsList from "../components/MissionsList";
import ItemMission from "../components/MissionsList/ItemMission";
import bg1 from "../../../../assets/images/Mini-Game/bg-icon-mission.png";
import bg2 from "../../../../assets/images/Mini-Game/bg-icon-mission2.png";
import imgReelFooter from "../../../../assets/images/Event-2026/back1.png";
import imgReelFooterThadingyutTheme from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/img-reel-footer-thadingyut-2025-theme.png";
import imgReelFooterNewYear from "../../../../assets/images/Mini-Game/new-year-2025/1.png";
import Ao from "../../../../assets/images/Event-2026/ao1.png";
import {
  getDataMissionMiniGame,
  getDataSpinAwardMiniGame,
  setOpenPopupFooter,
} from "../store";
import ListPrizes from "./ListPrizes";
import CardChange from "../components/MissionCard/CardChange";
import {
  ID_GIFT_PLAY_LOTO_MINIGAME,
  ID_TAB_MINI_GAME,
  useNewYear2025Theme,
  useThadingyutTheme,
} from "../../../../helper/const";
import EventMarquee from "../components/EventMarquee";
import CollectPiece from "../CollectPiece";
import PieceCollection from "../PieceCollection";
import PrizeCollection from "../PrizeCollection";
import TakePrize from "../TakePrize";
import InviteUser from "../InviteUser";
import RequestPiece from "../RequestPiece";
import GivePiece from "../GivePiece";
import BuyMoreCoin from "../BuyMoreCoin";
// import { IS_EVENT_THADINGYUT_2025_THEME } from "../../../../helper/const";
import lotusIcon from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/lotus-icon.png";
import lanternIcon from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/lantern-icon.png";
import styled from "styled-components";
import footerTree from "../../../../assets/images/Mini-Game/new-year-2025/footer-tree.png";
import PuzzlePrizes from './PuzzlePrizes';
import MissionToEarnCoins from './MissionToEarnCoins';
import ChangeCoinsByBids from '../components/ChangeCoinsByBids/ChangeCoinsByBids';
import BasePopup from '../components/Popup';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { postMiniGameChangeAttempt } from '@api/miniGame';
import PopupCongratula from "../components/PopupFooter/PopupCongratula";
import PopupCongPiece from "../components/PopupFooter/PopupCongPiece";
import PopupEarnMore from '../components/PopupFooter/PopupEarnMore';
import ChangeCoins from '../components/PopupFooter/components/ChangeCoins';
import ImgChangeCoin from '../../../../assets/images/Event-2026/change-coin.png';
import ImgBackChangeCoin from '../../../../assets/images/Event-2026/back-change-coin.png';
import ImgChangeBid from '../../../../assets/images/Event-2026/popup-change-bid.png';
import ImgExit from '../../../../assets/images/Event-2026/exit.png';
import PopupChangeCoin from '../components/PopupChangeCoin/PopupChangeCoin';
import { getMiniGameGetMiniGameQuery } from 'dataLayer/miniGame';
import { useNavigate } from '@hooks/useNavigate';
import { queryKeyTurn } from 'dataLayer/user';

const POPUP_KEY = "popup_daily_last_show";
const ONE_DAY = 24 * 60 * 60 * 1000;

function MiniGamePageHome() {
  const { t } = useTranslation();
  const dataMiniGame = useSelector(curStateMiniGame);
  const { user, isAuthenticated, remainTurn, requireLogin, goToLogin } =
    useMiniGameAuth();
  const [bidTotal, setBidTotal] = useState(0);
  const [bid, setBid] = useState(1);
  const dataMissionMini = dataMiniGame.dataMissionMini || [];
  const history = useHistory();
  const IS_EVENT_THADINGYUT_2025_THEME = useThadingyutTheme();
  const IS_EVENT_NEW_YEAR_2025_THEME = useNewYear2025Theme();
  const [openPopupChangeCoin, setOpenPopupChangeCoin] = useState(false);
  const [openPopupChangeCoinSuccess, setOpenPopupChangeCoinSuccess] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const sectionRef = useRef(null);
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!user) return;

    const lastShowTime = localStorage.getItem(POPUP_KEY);
    const now = Date.now();

    const shouldShow =
      !lastShowTime ||
      now - Number(lastShowTime) >= ONE_DAY;

    if (shouldShow) {
      setShowPopup(true);
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem(POPUP_KEY, Date.now().toString());
    setShowPopup(false);
  };


  useEffect(() => {
    setBid(dataMiniGame?.popupEarnMore?.turn || 1);
  }, [dataMiniGame?.popupEarnMore?.turn]);

  const {
    dailyMissions = [],
    standardMissions = [],
    missionDetail = [],
  } = useMemo(() => {
    if (_.isEmpty(dataMissionMini)) {
      return {};
    }
    let dailyMissions = dataMissionMini.filter(
      (item) => item.is_one_time_daily
    );

    let missionDetail = dataMissionMini.filter(
      (item) => !item.is_one_time_daily
    );
    const standardMissions = missionDetail.slice(0, 3);
    return { dailyMissions, standardMissions, missionDetail };
  }, [dataMissionMini]);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getDataSpinAwardMiniGame());
    dispatch(getDataMissionMiniGame());
  }, []);

  const handleTurnMini = () => {
    if (!requireLogin()) {
      return;
    }
    setOpenPopupChangeCoin(true);
    // dispatch(
    //   setOpenPopupFooter({
    //     isShowPopup: true,
    //     step: "change Coins",
    //     turn: bid,
    //   })
    // );
  };

  const changeAttemptMutation = useMutation({
    mutationFn: postMiniGameChangeAttempt,
    onSuccess: async (data) => {
      dispatch(getDataSpinAwardMiniGame());
      dispatch(getDataMissionMiniGame());
      const res = await dispatch(getDataSpinUserMiniGame());
      dispatch(
        setDataSpinLeft({
          spin_left: res?.spin_left,
          spin_left_free: res?.spin_left_free,
          spin_left_super: res?.spin_left_super,
        }),
      );
      setOpenPopupChangeCoin(false)
      setOpenPopupChangeCoinSuccess(true)
    },
    onError: (error) => {
      console.log("Error", error);
    },
  });

  const handleSubmitChangeCoin = async () => {
    changeAttemptMutation.mutate(
      {
        bid_number: bid,
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries([queryKeyTurn]);
        },
      }
    );
  }

  useEffect(() => {
    if (remainTurn?.length) {
      const bidTotal = remainTurn
        ?.filter((pack) => pack?.type !== 1)
        ?.reduce((acc, pack) => acc + pack?.turn, 0);
      setBidTotal(bidTotal);
    }
  }, [remainTurn]);

  const handleToBuyTurn = () => {
    history.push(PATH.PACKAGE);
  };

  const dataAwardList = useMemo(() => {
    if (!Array.isArray(dataMiniGame.dataAwardListMini) || _.isEmpty(dataMiniGame.dataAwardListMini)) {
      return [];
    }
    return [...dataMiniGame.dataAwardListMini].sort(
      (a, b) => Number(a.rank) - Number(b.rank)
    );
  }, [dataMiniGame.dataAwardListMini]);

  return (
    <div
      className={`container-minigame ${IS_EVENT_THADINGYUT_2025_THEME
        ? "thadingyut-theme"
        : IS_EVENT_NEW_YEAR_2025_THEME
          ? "new-year-25-theme"
          : ""
        }`}
    >
      <div className='minigame-home-header position-relative'>
        <EventMarquee />
        <HeaderAction />
        <TitleLogo
          className={`${IS_EVENT_THADINGYUT_2025_THEME ? "thadingyut-theme-logo" : ""
            }`}
          logo={
            IS_EVENT_THADINGYUT_2025_THEME
              ? logoShwePuzzleThadingyutTheme
              : IS_EVENT_NEW_YEAR_2025_THEME
                ? logoShwePuzzleNewYear
                : logoShwePuzzle
          }
        />
        <ActionComponent />
        <div ref={sectionRef} id="mission-section">
          <Reel />
        </div>

        {/* {IS_EVENT_NEW_YEAR_2025_THEME ? null : (
          <img
            src={
              IS_EVENT_THADINGYUT_2025_THEME
                ? imgReelFooterThadingyutTheme
                : imgReelFooter
            }
            alt=''
            className='mini-game-img-reel-footer'
          />
        )} */}

        {/* <img src={imgReelFooter} alt="" className="mini-game-img-reel-footer" /> */}
      </div>
      <div className='mission-container-minigame__body position-relative'>
        {IS_EVENT_NEW_YEAR_2025_THEME && (
          <div className='mini-game-img-reel-footer-wrapper'>
            <img
              srcSet={`${imgReelFooterNewYear} 2x`}
              alt=''
              className='mini-game-img-reel-footer'
            />
          </div>
        )}
        {/* {!IS_EVENT_THADINGYUT_2025_THEME && !IS_EVENT_NEW_YEAR_2025_THEME && (
          <img src={bg1} alt='' className='bg-mission-body' />
        )}
        {!IS_EVENT_THADINGYUT_2025_THEME && !IS_EVENT_NEW_YEAR_2025_THEME && (
          <img src={bg2} alt='' className='bg2-mission-body' />
        )} */}

        <PuzzlePrizes />
        {/* <MissionsList title={t("PUZZLE PRIZES")}>
          <ListPrizes dataAwardList={dataAwardList || []} />
        </MissionsList> */}
        <MissionToEarnCoins />
        {/* <MissionsList
          title={t("mini_game.homepage.daily_missions")}
          data={dailyMissions}
        >
          {dailyMissions.map((item, index) => {
            return (
              <Fragment key={`dailay_${item.id}`}>
                <ItemMission data={item} isDaily />
              </Fragment>
            );
          })}
        </MissionsList> */}

        {/* <MissionsList
          title={t("mini_game.standard_missions.title")}
          data={missionDetail}
        >
          {standardMissions.map((item, index) => {
            return (
              <Fragment key={`standar_${item.id}`}>
                <ItemMission data={item} />
              </Fragment>
            );
          })}
          <Link
            to={`${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.collectPiece}`}
            className={`view-all-mission ${IS_EVENT_THADINGYUT_2025_THEME ? "thadingyut-theme" : ""
              } ${IS_EVENT_NEW_YEAR_2025_THEME ? "new-year-25-theme" : ""}`}
          >
            {t("mini_game.standard_missions.view_all")}
          </Link>
        </MissionsList> */}
        <div>
          <ChangeCoinsByBids
            setBid={setBid}
            bid={bid}
            bidTotal={bidTotal}
            handleTurnMini={handleTurnMini}
            userInfo={user}
            showDataLogin={goToLogin}
            handleToBuyTurn={handleToBuyTurn}
            isAuthenticated={isAuthenticated}
          />
        </div>
        {/* <div className='mini-game-change-container'>
          <MissionsList title={t("CHANGE COINS BY BIDS")}>
            <CardChange
              setBid={setBid}
              bid={bid}
              bidTotal={bidTotal}
              handleTurnMini={handleTurnMini}
              userInfo={user}
              showDataLogin={goToLogin}
              handleToBuyTurn={handleToBuyTurn}
            />
            {isAuthenticated && (bidTotal === 0 || bidTotal < bid) ? (
              <ErrorContainer>
                <div className='content-error-mini-change'>
                  {bidTotal === 0
                    ? t("mini_game.standard_missions.no_turns_left")
                    : t("mini_game.standard_missions.number_exceeds")}
                </div>
                <div
                  className='content-error-mini-buy'
                  onClick={handleToBuyTurn}
                >
                  {t("mini_game.standard_missions.buy_more_turns")}
                </div>
              </ErrorContainer>
            ) : null}
          </MissionsList>
        </div> */}
        {IS_EVENT_THADINGYUT_2025_THEME && (
          <LanternIconContainer>
            <img src={lanternIcon} alt='Lantern Icon' />
          </LanternIconContainer>
        )}
        {IS_EVENT_THADINGYUT_2025_THEME && (
          <LotusIconContainer>
            <img src={lotusIcon} alt='Lotus Icon' />
          </LotusIconContainer>
        )}

        {IS_EVENT_NEW_YEAR_2025_THEME && (
          <div
            style={{
              position: "absolute",
              zIndex: 1,
              bottom: 0,
              left: 0,
              right: 0,
              width: "100%",
              pointerEvents: "none",
            }}
          >
            <img
              src={footerTree}
              alt='footer-tree'
              className='footer-tree-new-year-25-theme'
              style={{
                width: "100%",
              }}
            />
          </div>
        )}

        <img src={Ao} alt="" className='footer-ao' />
      </div>

      <PopupChangeCoin
        visible={openPopupChangeCoin}
        type="change"
        bid={bid}
        setVisible={setOpenPopupChangeCoin}
        submit={handleSubmitChangeCoin}
        isLoading={changeAttemptMutation.isLoading}
      />

      <PopupChangeCoin
        visible={openPopupChangeCoinSuccess}
        setVisible={setOpenPopupChangeCoinSuccess}
        type="success"
        bid={bid}
        submit={() => {
          setOpenPopupChangeCoinSuccess(false);
          if (sectionRef.current) {
            sectionRef.current.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        }}
      />

      <PopupChangeCoin
        visible={showPopup}
        setVisible={handleClose}
        type="daily"
        data={dailyMissions}
        submit={handleClose}
      />
    </div>
  );
}

const ErrorContainer = styled.div`
  background-color: transparent;
  padding: 16px;
  border-radius: 12px;

  .content-error-mini-change,
  .content-error-mini-buy {
    font-size: 14px;

    @media (min-width: 768px) {
      font-size: 16px;
    }
  }
`;

const LanternIconContainer = styled.div`
  position: absolute;
  right: 0;
  pointer-events: none;
  z-index: 2;
  transform: rotate(35deg) translate(18%, -30%);
  max-width: 30%;
  top: 0;

  @media (max-width: 1440px) {
    max-width: 35%;
  }

  @media (max-width: 600px) {
    transform: rotate(35deg) translate(30%, -25%);
  }

  @media (max-width: 492px) {
    transform: rotate(35deg) translate(41%, -5%);
  }
`;

function MiniGameRouteById() {
  const { id: tab } = useParams();
  const tabId = tab || ID_TAB_MINI_GAME.home;

  switch (tabId) {
    case ID_TAB_MINI_GAME.collectPiece:
      return <CollectPiece />;
    case ID_TAB_MINI_GAME.pieceCollection:
      return <PieceCollection />;
    case ID_TAB_MINI_GAME.prizeCollection:
      return <PrizeCollection />;
    case ID_TAB_MINI_GAME.takePrize:
      return <TakePrize />;
    case ID_TAB_MINI_GAME.inviteUser:
      return <InviteUser />;
    case ID_TAB_MINI_GAME.requestPiece:
      return <RequestPiece />;
    case ID_TAB_MINI_GAME.givePiece:
      return <GivePiece />;
    case ID_TAB_MINI_GAME.buyMoreCoin:
      return <BuyMoreCoin />;
    case ID_TAB_MINI_GAME.home:
    default:
      return <MiniGamePageHome />;
  }
}

export default function WorldCup2026() {
  const { data, isLoading } = useQuery(getMiniGameGetMiniGameQuery());
  const navigate = useNavigate()

  // check nếu sự kiện kết thúc chuyển về home
  useEffect(() => {
    if (
      !isLoading &&
      (
        (data?.is_show === 0 && data?.is_finished === 0) ||
        data?.is_finished === 1
      )
    ) {
      navigate("/", { replace: true });
    }
  }, [data, isLoading, navigate]);

  if (isLoading) {
    return null;
  }

  if (
    (data?.is_show === 0 && data?.is_finished === 0) ||
    data?.is_finished === 1
  ) {
    return null;
  }

  return (
    <div className="minigame-module">
      <MiniGameProvider>
        {/* <PopupCongPiece type={ID_GIFT_PLAY_LOTO_MINIGAME.no_coins} /> */}
        <MiniGameRouteById />
      </MiniGameProvider>
    </div>
  );
}

const LotusIconContainer = styled.div`
  position: absolute;
  right: 0;
  transform: rotate(335deg) translate(30%, -15%);
  z-index: 0;
  pointer-events: none;

  @media (max-width: 768px) {
    transform: rotate(335deg) translate(40%, -8%);
    img {
      max-width: 85%;
    }
  }
`;
